<div>
  <div class="card text-center">
    <div class="card-header">
      <h5>
        {{ 'Sellers.Dashboard.InviteEarn' | translate }}
      </h5>
    </div>
    <div class="card-body">
      <h2 class="font-weight-bold">
        {{ 'Sellers.Products.Get' | translate }} {{referalInfo.value.sender_value}} EGP
      </h2>
      <p>{{ 'Sellers.Products.EasykashReward' | translate }}</p>
      <p>
        <b>{{ 'Sellers.Products.Notice' | translate }}: </b>
        {{ 'Sellers.Products.PaymentsOver' | translate }} {{referalInfo.value.limit_value}} EGP {{ 'Sellers.Products.ConsideredSuccessful' | translate }}.
      </p>
      <input class="d-block"
             style="opacity: 0"
             type="text"
             value="{{baseUrl + referalInfo.code}}"
             #userInput />
      <div class="alert alert-info pb-0">
        <p>
          {{ 'Sellers.Products.ShareReferralLink' | translate }}: <b class="ml-2 mr-2">{{baseUrl + referalInfo.code}} </b>
          <button aria-label="Copy to clipboard" (click)="copyInputMessage(userInput)" class="btn btn-light mx-2">
            <i class="far fa-copy pr-0"></i>
          </button>
        </p>
      </div>
    </div>
  </div>

  <div class="mt-4 row justify-content-around">
    <h4 class="mb-4 col-12 text-center">
      {{ 'Sellers.Products.InvitationsStatus' | translate }}:
    </h4>
    <div class="card col-4 p-4 bg-info text-white">
      <div>{{ 'Sellers.Products.PeopleReferred' | translate }}</div>
      <h3>{{referalInfo.countAll}}</h3>
    </div>
    <div class="card col-4 p-4 bg-success text-white">
      <div>{{ 'Sellers.Products.SuccessfulReferrals' | translate }}</div>
      <h3>{{referalInfo.countRedeemed}}</h3>
    </div>
  </div>
</div>
